import { render, staticRenderFns } from "./EditSpec.vue?vue&type=template&id=11f51c85&scoped=true"
import script from "./EditSpec.vue?vue&type=script&lang=js"
export * from "./EditSpec.vue?vue&type=script&lang=js"
import style0 from "./EditSpec.vue?vue&type=style&index=0&id=11f51c85&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11f51c85",
  null
  
)

export default component.exports